<template>
	<div>
		<span v-if="modelValue">
			<o-field>
				<o-icon icon="check" v-if="myStrategy"></o-icon>
				<o-button size="small" outlined @click="OnMyStrategy" v-if="myStrategy === false">
					Confirm as my strategy
				</o-button>
				<template #message>
					<span v-if="myStrategy">My strategy</span>
				</template>
			</o-field>
		</span>
		<span v-else><o-button size="small" outlined @click="OnNominate">Nominate</o-button></span>
	</div>
</template>
<script>
	import { ref, inject, onMounted } from "vue";
	import store from "@/store";
	export default {
		props: {
			modelValue: {
				type: Boolean,
				default: false
			},
			companyId: {
				type: [String, Number],
				default: undefined
			}
		},
		emits: ["update:modelValue", "nominate", "confirm"],
		setup(props, context) {
			const $http = inject("$http");
			const myStrategy = ref(null);

			const OnNominate = () => {
				context.emit("nominate");
			};
			const OnMyStrategy = () => {
				context.emit("confirm", { myStrategy: myStrategy });
			};

			const GetMyStrategy = () => {
				$http.get("/api/v2/company/" + props.companyId + "/strategy").then((resp) => {
					myStrategy.value = resp.data;
				});
			};

			onMounted(() => {
				if (props.modelValue && props.companyId && store.getters.isLoggedIn) {
					GetMyStrategy();
				}
			});

			return {
				myStrategy,
				OnNominate,
				OnMyStrategy
			};
		}
	};
</script>